import { getISODate, parseTimeFromMilliseconds } from "../../helpers";
export const mapKickOffTime = (x, timezone) => {
    x.kickOffTime = "";
    if (x.isInKickOffState) {
        const eventStartDate = getISODate(x.startEventDate, timezone);
        const now = getISODate(new Date().toISOString(), timezone);
        const timeLeft = (!now || !eventStartDate || now >= eventStartDate) ? 0 : now.getTime() - eventStartDate.getTime();
        x.kickOffTime = parseTimeFromMilliseconds(timeLeft);
        if (parseInt(x.kickOffTime) <= 0) {
            x.isInKickOffState = false;
            x.kickOffTime = "";
        }
    }
    return x;
};
//# sourceMappingURL=mapKickOffTime.js.map